import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "data-testid": "list-providers-page",
  class: "page list-providers-page"
}
const _hoisted_2 = {
  key: 0,
  class: "text-center list-pagination"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_AppTable = _resolveComponent("AppTable")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_AppLoader = _resolveComponent("AppLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, { fluid: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_layout, { class: "mt-4 pa-0" }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createElementVNode("div", { style: {"align-self":"center"} }, [
              _createElementVNode("h2", { class: "section-title" }, "Providers")
            ], -1)
          ]))]),
          _: 1
        }),
        (!_ctx.fetchingProviders && _ctx.providers)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              class: "mt-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AppTable, {
                  "data-testid": "ProviderTable",
                  "table-data": _ctx.tableData,
                  onRemoveItemClick: _cache[0] || (_cache[0] = (e) => _ctx.removeProvider(e)),
                  disablePagination: true
                }, null, 8, ["table-data"]),
                (_ctx.totalPage > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      (_ctx.totalPage > 1)
                        ? (_openBlock(), _createBlock(_component_v_pagination, {
                            key: 0,
                            modelValue: _ctx.currPage,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currPage) = $event)),
                            length: _ctx.totalPage,
                            "active-color": "primary",
                            density: "comfortable",
                            "prev-icon": "fa fa-caret-left",
                            "next-icon": "fa fa-caret-right",
                            onNext: _cache[2] || (_cache[2] = ($event: any) => (_ctx.currPage + 1)),
                            onPrevious: _cache[3] || (_cache[3] = ($event: any) => (_ctx.currPage - 1)),
                            "total-visible": 7
                          }, null, 8, ["modelValue", "length"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.removingProvider || _ctx.fetchingProviders)
      ? (_openBlock(), _createBlock(_component_AppLoader, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}